import axios from 'axios'
import router from '@/router';

export default function fetch(url, options = {}) {
  const token = localStorage.getItem('token') || '';
  const method = options.method || 'GET';
  const params = {
    url,
    method,
    headers: {
      'Authorization': token,
      'Content-Type': options.contentType || 'application/json'
    },
  };
  if (options.withoutToken) {
    delete params.headers.Authorization;
  }
  if (method === 'GET') {
    params.params = options.data || {};
  } else {
    params.data = options.data || {};
  }
  return new Promise((resolve, reject) => {
    axios(params).then(res => {
      if (res.status === 200) {
        if (url === '/uaa/wechat/token' && res.data.access_token) {
          resolve(res.data);
        } else if (+res.data.code === 200) {
          resolve(res.data.data);
        } else if (res.data.error === 'invalid_token') {
          localStorage.removeItem('token');
          router.replace('/login');
        } else {
          reject(res.data.data);
        }
      }
    }).catch(err => {
      reject(err);
    });
  })
}
